import { useQueryClient } from '@tanstack/react-query';
export function createFavoriteRepository(config) {
    const { repository, client } = config;
    function getFindKey() {
        return ['favorite', 'find'];
    }
    return {
        useFind(context, props, options) {
            const query = repository.useQuery({
                ...options,
                queryKey: getFindKey(),
                async queryFn() {
                    const response = await client.user.default.favoriteList(props);
                    return response.data.data;
                },
            });
            return query;
        },
        useCreate(context) {
            const queryClient = useQueryClient();
            return repository.useMutation(context, {
                async mutationFn(props) {
                    const response = await client.user.default.favoriteCreate({
                        favoriteCreateRequest: props,
                    });
                    return response.data;
                },
                onSuccess(data) {
                    const queryKey = getFindKey();
                    queryClient.setQueryData(queryKey, (old) => {
                        return [...(old ?? []), data];
                    });
                },
            });
        },
        useDelete(context) {
            const queryClient = useQueryClient();
            return repository.useMutation(context, {
                async mutationFn(props) {
                    const response = await client.user.default.favoriteDelete(props);
                    return props;
                },
                onSuccess(data) {
                    const queryKey = getFindKey();
                    queryClient.setQueryData(queryKey, (old) => {
                        return old?.filter((item) => item.id !== data.favoriteId);
                    });
                },
            });
        },
    };
}
//# sourceMappingURL=favoriteRepository.js.map